var NAYIN = {
    /**
     * 纳音的数据
     */
    nayinArray: [
        ['海中金', '炉中火', '大林木', '路旁土', '剑锋金'],
        ['山头火', '涧下水', '城头土', '白蜡金', '杨柳木'],
        ['泉中水', '屋上土', '霹雳火', '松柏木', '长流水'],
        ['沙中金', '山下火', '平地木', '壁上土', '金箔金'],
        ['覆灯火', '天河水', '大驿土', '钗钏金', '桑柘木'],
        ['大溪水', '沙中土', '天上火', '石榴木', '大海水'],
    ],
    /**
     * 获取纳音
     * @param {干} gan 
     * @param {支} zhi 
     */
    getNaYinByGanZhi(gan, zhi) {
        // 干支相等
        var tempZhi = 0, lun = 0, dui = 0, ganzhiKey = gan+''+zhi;
        // 轮询六十甲子
        while(lun <= 6) {
            var tempKey = '';
            for(var i = 0; i < 10; i++) {
                var key = i+''+tempZhi, 
                    value = NAYIN.nayinArray[lun][dui];
                // console.log('lun-----', key, value);
                if(ganzhiKey == key) {
                    return value;
                }
                tempZhi = tempZhi < 11 ? tempZhi+1 : 0;
                lun = i == 9 ? lun+1 : lun;
                dui = i%2 != 0 ? dui+1 : dui;
                dui = dui <= 4 ? dui : 0;
            }
            if(lun == 6) {
                break;
            }
        }
        return '';
    }
}

export {
    NAYIN
}